import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export default class ManagedUser extends Model {
  [Type] = 'managed-user' as const;

  @attr('string') declare email: string;
  @attr('string') declare lastLogin: string | null;
  @attr('string') declare name: string;
  @attr('number') declare subscriptionCount: number;
}
